import { v4 as uuidv4 } from 'uuid';

export function randomUUID(): string {
	if ('randomUUID' in crypto) {
		return crypto.randomUUID();
	}

	return uuidv4();
}
